import type { FC, SVGProps } from 'react';
import type { AlertCode } from 'types';
import { Icons } from 'ui-kit';

export const ALERTS_ICONS: Partial<
  Record<AlertCode, { icon: FC<SVGProps<SVGSVGElement>> }>
> = {
  Offline: {
    icon: Icons.WifiSlash
  },
  WaterIsOver: {
    icon: Icons.WaterLower
  },
  WaterPressureLow: {
    icon: Icons.TachometerSlowest
  },
  DoorIsOpen: {
    icon: Icons.DoorOpen
  },
  NoSales2h: {
    icon: Icons.ExclamationTriangle
  },
  NoBankcardSales2h: {
    icon: Icons.Card
  },
  ExchangeIsOver: {
    icon: Icons.SackDollar
  },
  SimBalanceLow: {
    icon: Icons.SimCard
  },
  TankMinLevel: {
    icon: Icons.TintSlash
  },
  FiscalError: {
    icon: Icons.VoteNay
  },
  BillValidatorError: {
    icon: Icons.MoneyBillAlt
  },
  HopperError: {
    icon: Icons.CoinsDutone
  },
  RebootRequired: {
    icon: Icons.Repeat
  },
  ExternalPowerIsOff: {
    icon: Icons.ExternalPowerIsOff
  },
  Leakage: {
    icon: Icons.Leakage
  },
  HighTemperatureInputWater: {
    icon: Icons.HighTemperatureInputWater
  },
  InefficientFlushing: {
    icon: Icons.Flushing
  },
  UVlampDefective: {
    icon: Icons.UV
  }
};
